import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Config, Driver, driver, DriveStep } from 'driver.js';
import { AccountStateService } from './account-state.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class DemoTourService {
  private _steps: DriveStep[] = [
    {
      element: '#nav-bar',
      popover: {
        title: this._translate.instant('RELEASE.V1_6.STEP_1_TITLE'),
        description: this._translate.instant('RELEASE.V1_6.STEP_1_DESCR'),
        side: 'right',
        align: 'start',
      },
    },
    {
      element: '#tab-demo-tour-step-2',
      popover: {
        title: this._translate.instant('RELEASE.V1_6.STEP_2_TITLE'),
        description: this._translate.instant('RELEASE.V1_6.STEP_2_DESCR'),
        side: 'right',
        align: 'start',
        onNextClick: () => {
          this._navigateAndNextStep('/management');
        },
      },
    },
    {
      element: '#demo-tour-step-3',
      popover: {
        title: this._translate.instant('RELEASE.V1_6.STEP_3_TITLE'),
        description: this._translate.instant('RELEASE.V1_6.STEP_3_DESCR'),
        side: 'bottom',
        align: 'start',
      },
    },
    {
      element: '#demo-tour-step-4',
      popover: {
        title: this._translate.instant('RELEASE.V1_6.STEP_4_TITLE'),
        description: this._translate.instant('RELEASE.V1_6.STEP_4_DESCR'),
        side: 'bottom',
        align: 'start',
        onNextClick: () => {
          this._navigateAndNextStep('/administration');
        },
      },
    },
    {
      element: '#demo-tour-step-5',
      popover: {
        title: this._translate.instant('RELEASE.V1_6.STEP_5_TITLE'),
        description: this._translate.instant('RELEASE.V1_6.STEP_5_DESCR'),
        side: 'right',
        align: 'start',
        onNextClick: () => {
          this._navigateAndNextStep('/my-account');
        },
      },
    },
    {
      element: '#demo-tour-step-6',
      popover: {
        title: this._translate.instant('RELEASE.V1_6.STEP_6_TITLE'),
        description: this._translate.instant('RELEASE.V1_6.STEP_6_DESCR'),
        side: 'right',
        align: 'start',
        onNextClick: () => {
          this._navigateAndNextStep('/resources/update');
        },
      },
    },
    {
      element: '#demo-tour-step-7',
      popover: {
        title: this._translate.instant('RELEASE.V1_6.STEP_7_TITLE'),
        description: this._translate.instant('RELEASE.V1_6.STEP_7_DESCR'),
        side: 'right',
        align: 'start',
      },
    },
  ];

  private _driverElement: Config = {
    showProgress: true,
    progressText: '{{current}} / {{total}}',
    nextBtnText: this._translate.instant('COMMON.NEXT'),
    doneBtnText: this._translate.instant('COMMON.EXPLORE'),
    popoverClass: 'driverjs-theme',
    showButtons: ['next'],
    onDestroyed: (element, step) => {
      if (step?.element !== this._steps[this._steps.length - 1]?.element) {
        // last-step
        this._router.navigate(['/resources/update']); // Force user go to resources
      }
    },
  };

  private _driver: Driver;

  constructor(
    private _router: Router,
    private _accountStateService: AccountStateService,
    private _translate: TranslateService
  ) {}

  runDemoTour() {
    if (
      !this._accountStateService.$account()?.administrator &&
      !this._accountStateService.$account()?.supervisor
    ) {
      this._steps.filter(step => step.element !== '#demo-tour-step-5');
    }
    this._driver = driver({ ...this._driverElement, steps: this._steps });
    this._driver.drive();
  }

  private _navigateAndNextStep(path: string) {
    this._router.navigate([path]).then(() => {
      setTimeout(() => {
        this._driver?.moveNext();
      }, 300);
    });
  }
}
